import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { useTheme, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// import "react-day-picker/lib/style.css";
import "fontsource-muli";
import CustomPaper from "../../../../components/CustomPaper";
import CustomText, { getFontSize } from "../../../../components/CustomText";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Color from "../../../../../utils/Color";
import _ from "lodash";
import { getFontWeight } from "../../../../components/CustomText";
import { usePagination } from "@material-ui/lab/Pagination";
import Fade from "@material-ui/core/Fade";
import { Zoom } from "@material-ui/core";
import { connect } from "react-redux";
import CustomDropDown from "../../../../components/CustomDropDown";
import CustomButton from "../../../../components/CustomButton";
import Image from "../../../../../assets";
import Divider from "@material-ui/core/Divider";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import SendIcon from "@material-ui/icons/Send";
import CustomTextInput from "../../../../components/CustomTextInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import MessageList from "../MessageList";
import CustomModalV2 from "../../../../components/CustomModalV2";
import AnimationPage from "../../../../components/LiveChatLoadingAnimation";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: Color.backgroundColor,
    color: Color.primaryTextColor,
    fontFamily: "Muli",
    ...getFontWeight("800"),
    fontSize: 14,
    textAlign: "center",
  },
  body: {
    color: Color.primaryTextColor,
    fontFamily: "Muli",
    ...getFontWeight("600"),
    fontSize: 14,
    textAlign: "center",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  // root: {
  //   '&:nth-of-type(odd)': {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  // },
}))(TableRow);

const enquiryType = [
  { value: 1, label: "edf" },
  { value: 2, label: "abc" },
];

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const WebView = ({
  classes,
  selectedFiles = [],
  closeMessageStatus,
  handleAttachedFiles,
  createChatBtns,
  localUpdateMsgList,
  onClickSendMessage,
  handleMessageChange,
  onClickSendMessageNormal,
  userMsg,
  startInit,
  onCloseLiveChat,
  generalsQ,
  handleBottomRef,
  homeFireQ,
  maidQ,
  savingQ,
  motorQ,
  goToGeneral,
  goToHome,
  goToMaid,
  goToMotor,
  goToSaving,
  goBack,
  toGeneral,
  toHome,
  toMaid,
  toSaving,
  toMotor,
  showCat,
  sendAskMsg,
  liveChatButtonClicked,
  localQueueNum,
  localQueueT,
  onClickMenu,
  showCatM,
  localEnableLiveChat,
  handleDeleteImage,
  liveChatCallBackFlag,
  hideLiveChat,
  sendLikeButton,
  blockTheChat,
  ...props
}) => {
  // console.log(data);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);
  const [searchClear, setSearchClear] = React.useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const { items } = usePagination({
    // count:
    //   showPolicyList.length % 8 === 0
    //     ? parseInt(showPolicyList.length / 8)
    //     : parseInt(showPolicyList.length / 8) + 1,
    count: 2,
    color: "primary",
    page: page,
    onChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage,
  });

  const customStylesEnquiryType = (emptyEnquiry) => ({
    option: (provided, state) => ({
      ...provided,
      color: Color.primaryTextColor,
      backgroundColor: state.isSelected ? "#f0f0f0" : "white",
      fontFamily: "Muli",
      fontSize: "15px",
    }),
  });

  // const { getEDocFilterParam, getEDocFilterParamData } = props;
  // const prevAmount = usePrevious({ getEDocFilterParamData });
  // useEffect((prevProps) => {
  //   getEDocFilterParam();

  //   console.log("getEDocFilterParamData", props.getEDocFilterParamData);
  // }, []);

  // useEffect(() => {
  //   if (prevAmount !== getEDocFilterParamData) {
  //     const filterEdocParamData = profileSelectors.getEDocFilterParamDataData(
  //       getEDocFilterParamData
  //     );
  //     const categoryDropDown = profileSelectors.getEDocFilterParamCategoryDropDownLists(
  //       filterEdocParamData
  //     );
  //     const dateDropDownLists = profileSelectors.getEDocFilterParamDateDropDownLists(
  //       filterEdocParamData
  //     );
  //     const policyDropDownLists = profileSelectors.getEDocFilterParamPolicyDropDownLists(
  //       filterEdocParamData
  //     );
  //     console.log(
  //       "getEDocFilterParamData",
  //       categoryDropDown,
  //       dateDropDownLists
  //     );

  //   }
  // }, [getEDocFilterParamData]);

  // const filterEdocParamData = profileSelectors.getEDocFilterParamDataData(
  //   getEDocFilterParamData
  // );
  // const categoryDropDown = profileSelectors.getEDocFilterParamCategoryDropDownLists(
  //   filterEdocParamData
  // );
  // const dateDropDownLists = profileSelectors.getEDocFilterParamDateDropDownLists(
  //   filterEdocParamData
  // );
  // const policyDropDownLists = profileSelectors.getEDocFilterParamPolicyDropDownLists(
  //   filterEdocParamData
  // );

  const renderReviewConfirmDialog = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", marginLeft: 27 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            fontSize: "14px",
            color: "#fff",
            fontWeight: "300",
          }}
        >
          {localQueueNum !== "" && localQueueT !== ""
            ? "People in front of you"
            : ""}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 10,
            fontSize: "35px",
            fontWeight: "bold",
            color: "#fff",
          }}
        >
          <AnimationPage />
          <div
            style={{ marginTop: "1.4rem", zIndex: "99", position: "absolute" }}
          >
            {localQueueNum}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            fontSize: "14px",
            color: "#fff",
            marginTop: 10,
          }}
        >
          {localQueueNum !== "" && localQueueT !== ""
            ? `Est. waiting time : ${localQueueT}mins`
            : ""}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            fontSize: "28px",
            color: "#fff",
            marginTop: 20,
            fontWeight: "bold",
          }}
        >
          Hello there
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            fontSize: "16px",
            color: "#fff",
            marginTop: 10,
            textAlign: "center",
          }}
        >
          You’re in line! Our agent will be in touch with you shortly.
        </div>
        {liveChatCallBackFlag ? (
          <>
            {" "}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                fontSize: "14px",
                color: "#fff",
                marginTop: 30,
              }}
            >
              Tired of waiting?
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                fontSize: "16px",
                color: "#fff",
                border: "2px solid #FFFFFF",
                borderRadius: "6px",
                marginTop: 20,
                marginLeft: "20%",
                marginRight: "20%",
                padding: "10px",
              }}
              onClick={()=>onClickSendMessage("Schedule Callback","Schedule Callback")}
            >
              Schedule a callback
            </div>
          </>
        ) : (
          false
        )}
      </div>
    );
  };

  const renderMaidQuestion = () => {
    return (
      <CustomPaper
        design={classes.paperStyleSecond}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          justify="flex-end"
          style={{ padding: 20 }}
        >
          <CustomText
            design={classes.subtitle}
            style={{ color: "#00B4AF", cursor: "pointer" }}
            onClick={goBack}
          >
            back
          </CustomText>
        </Grid>
        <Divider className={classes.dividerStyle} />
        {maidQ.map((item, index) => {
          return (
            <>
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 10,
                  marginBottom: 10,
                  paddingLeft: 15,
                  paddingRight: 20,
                }}
              >
                <Grid style={{ display: "flex", flexDirection: "row" }}>
                  <span
                    style={{
                      marginLeft: 15,
                      color: "#00B4AF",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => sendAskMsg(item.value)}
                  >
                    {item.value}
                  </span>
                </Grid>
              </Grid>
              <Divider className={classes.dividerStyle} />
            </>
          );
        })}
      </CustomPaper>
    );
  };

  const renderSavingQuestion = () => {
    return (
      <CustomPaper
        design={classes.paperStyleSecond}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          justify="flex-end"
          style={{ padding: 20 }}
        >
          <CustomText
            design={classes.subtitle}
            style={{ color: "#00B4AF", cursor: "pointer" }}
            onClick={goBack}
          >
            back
          </CustomText>
        </Grid>
        <Divider className={classes.dividerStyle} />
        {savingQ.map((item, index) => {
          return (
            <>
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 10,
                  marginBottom: 10,
                  paddingLeft: 15,
                  paddingRight: 20,
                }}
              >
                <Grid style={{ display: "flex", flexDirection: "row" }}>
                  <span
                    style={{
                      marginLeft: 15,
                      color: "#00B4AF",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => sendAskMsg(item.value)}
                  >
                    {item.value}
                  </span>
                </Grid>
              </Grid>
              <Divider className={classes.dividerStyle} />
            </>
          );
        })}
      </CustomPaper>
    );
  };

  const renderMotorQuestion = () => {
    return (
      <CustomPaper
        design={classes.paperStyleSecond}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          justify="flex-end"
          style={{ padding: 20 }}
        >
          <CustomText
            design={classes.subtitle}
            style={{ color: "#00B4AF", cursor: "pointer" }}
            onClick={goBack}
          >
            back
          </CustomText>
        </Grid>
        <Divider className={classes.dividerStyle} />
        {motorQ.map((item, index) => {
          return (
            <>
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 10,
                  marginBottom: 10,
                  paddingLeft: 15,
                  paddingRight: 20,
                }}
              >
                <Grid style={{ display: "flex", flexDirection: "row" }}>
                  <span
                    style={{
                      marginLeft: 15,
                      color: "#00B4AF",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => sendAskMsg(item.value)}
                  >
                    {item.value}
                  </span>
                </Grid>
              </Grid>
              <Divider className={classes.dividerStyle} />
            </>
          );
        })}
      </CustomPaper>
    );
  };

  const renderHomeQuestion = () => {
    return (
      <CustomPaper
        design={classes.paperStyleSecond}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          justify="flex-end"
          style={{ padding: 20 }}
        >
          <CustomText
            design={classes.subtitle}
            style={{ color: "#00B4AF", cursor: "pointer" }}
            onClick={goBack}
          >
            back
          </CustomText>
        </Grid>
        <Divider className={classes.dividerStyle} />
        {homeFireQ.map((item, index) => {
          return (
            <>
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 10,
                  marginBottom: 10,
                  paddingLeft: 15,
                  paddingRight: 20,
                }}
              >
                <Grid style={{ display: "flex", flexDirection: "row" }}>
                  <span
                    style={{
                      marginLeft: 15,
                      color: "#00B4AF",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => sendAskMsg(item.value)}
                  >
                    {item.value}
                  </span>
                </Grid>
              </Grid>
              <Divider className={classes.dividerStyle} />
            </>
          );
        })}
      </CustomPaper>
    );
  };

  const renderGeneralQuestion = () => {
    return (
      <CustomPaper
        design={classes.paperStyleSecond}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          justify="flex-end"
          style={{ padding: 20 }}
        >
          <CustomText
            design={classes.subtitle}
            style={{ color: "#00B4AF", cursor: "pointer" }}
            onClick={goBack}
          >
            back
          </CustomText>
        </Grid>
        <Divider className={classes.dividerStyle} />
        {generalsQ.map((item, index) => {
          return (
            <>
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 10,
                  marginBottom: 10,
                  paddingLeft: 15,
                  paddingRight: 20,
                }}
              >
                <Grid style={{ display: "flex", flexDirection: "row" }}>
                  <span
                    style={{
                      marginLeft: 15,
                      color: "#00B4AF",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => sendAskMsg(item.value)}
                  >
                    {item.value}
                  </span>
                </Grid>
              </Grid>
              <Divider className={classes.dividerStyle} />
            </>
          );
        })}
      </CustomPaper>
    );
  };

  const handleCloseDialog = () => {
    return (
      <div>
        {closeMessageStatus ? (
          <div style={{ paddingLeft: 20, paddingRight: 20 }}>
            <Grid
              container
              spacing={2}
              direction="row"
              alignItems="center"
              justify="center"
              className={classes.alertMsg}
            >
              <Grid item xs={12}>
                <CustomText design={classes.alertTextStyle}>
                  Live chat marked as closed.
                </CustomText>
              </Grid>
            </Grid>
          </div>
        ) : (
          false
        )}
      </div>
    );
  };
  var sender = "";
  localUpdateMsgList &&
    Array.isArray(localUpdateMsgList) &&
    localUpdateMsgList.map((item, index) => {
      return (sender = item.Sender);
    });
  return (
    <Zoom
      in={true}
      {...(true ? { timeout: 600 } : {})}
      style={{ marginBottom: 100 }}
    >
      <div>
        {/* <Zoom
          in={true}
          style={{ transformOrigin: "0 0 0", transitionDelay: "600ms" }}
          {...(true ? { timeout: 600 } : {})}
        >
          {" "}
          <div>
            * Notes : e-Documents are available from DD MMM YYYY onwards.
          </div>
        </Zoom> */}

        <Zoom
          in={true}
          style={{ transformOrigin: "0 0 0", transitionDelay: "600ms" }}
          {...(true ? { timeout: 600 } : {})}
        >
          {/* <div>
            {" "}
            <div
              style={{
                marginBottom: 15,
                fontSize: "11px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <div>* Notes: &nbsp;</div>{" "}
              <div style={{ display: "flex", flexDirection: "column" }}>
                {" "}
                <div>
                  {" "}
                  1) eDocuments are available from 1 July 2022 onwards.
                </div>
                <div>
                  2) Existing documents uploaded on our portal before 1 July
                  2022 will also be made available for viewing.
                </div>
                <div>
                  3) To view your eDocuments, click on the respective hyperlink
                  of the eDocument you would like to view.
                </div>
              </div>
            </div>
            <CustomText design={classes.headerTextStyle}>eDocuments</CustomText>
          </div> */}

          {/* Etiqa Customer Care */}
          <Grid
            item
            xs={12}
            sm={12}
            style={{ display: "flex", flexDirection: "row" }}
          >
            <Grid item xs={12} sm={9}>
              {" "}
              <CustomPaper design={classes.paperStyle}>
                <Grid
                  container
                  spacing={0}
                  direction="row"
                  alignItems="center"
                  justify="space-between"
                  style={{ padding: 8.5, paddingLeft: 20 }}
                >
                  <CustomText design={classes.subtitle}>{hideLiveChat ? sender : "Trix"}</CustomText>
                  {localEnableLiveChat && !hideLiveChat ? (
                    <img
                      src={Image.liveChatBtn}
                      className={classes.imageLiveChatStyle}
                      style={{ cursor: "pointer" }}
                      onClick={liveChatButtonClicked}
                    />
                  ) : <div style={{paddingBottom:20,color:"white"}}>abc</div>}
                  {/* <img
                    src={Image.liveChatBtn}
                    className={classes.imageLiveChatStyle}
                    style={{ cursor: "pointer" }}
                    onClick={liveChatButtonClicked}
                  /> */}
                </Grid>

                <Divider className={classes.dividerStyle} />

                <MessageList
                  messageHistoryList={localUpdateMsgList}
                  handleBottomRef={handleBottomRef}
                  scroll={false}
                  createChatBtns={createChatBtns}
                  onClickSendMessage={onClickSendMessage}
                  sendLikeButton={sendLikeButton}
                  // loginName={loginName}
                  // onClickFileAttached={this.onClickFileAttached}
                />
                {handleCloseDialog()}
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                   
                    overflow: "scroll",
                    marginTop: 15,
                    marginLeft: 25,
                    marginBottom: 10,
                    maxWidth: window.innerWidth * 0.8,
                  }}
                >
                  {createChatBtns.length > 0 &&
                    createChatBtns.map((item, index) => {
                      return (
                        <div
                          style={{ marginBottom: 20, cursor: "pointer" }}
                          onClick={() =>
                            onClickSendMessage(item.title, item.payload,item.type)
                          }
                          className={classes.threeSelect}
                        >
                          {item.title}
                        </div>
                      );
                    })}
                
                </div> */}

                <Divider
                  className={classes.dividerStyle}
                  //style={{ marginTop: 76 }}
                />

                <Grid
                  container
                  style={{
                    marginTop: 20,
                    paddingBottom: 0,
                    paddingLeft: 20,
                  }}
                >
                  {selectedFiles.map((item, index) => (
                    <Grid
                      item
                      style={{
                        marginRight: 20,
                        marginBottom: 10,
                      }}
                      key={index}
                    >
                      <Grid container direction={"column"}>
                        {item.type === "application/pdf" ? (
                          <PictureAsPdfIcon
                            className={classes.selectedImageStyle}
                          />
                        ) : (
                          <img
                            src={`${item.src.base64}`}
                            className={classes.selectedImageStyle}
                          />
                        )}
                        <div onClick={() => handleDeleteImage(index)}>
                          <CustomText design={classes.cancelIconStyle}>
                            Remove
                          </CustomText>
                        </div>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>

                {toGeneral ? renderGeneralQuestion() : false}
                  {toHome ? renderHomeQuestion() : false}
                  {toMaid ? renderMaidQuestion() : false}
                  {toSaving ? renderSavingQuestion() : false}
                  {toMotor ? renderMotorQuestion() : false}
                  {showCatM ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        spacing={0}
                        direction="row"
                        alignItems="center"
                        justify="flex-start"
                        style={{ padding: 20, flexWrap: "nowrap" }}
                      >
                        <CustomText design={classes.subtitle}>
                          Popular Topics
                        </CustomText>
                      </Grid>
                      <Divider className={classes.dividerStyle} />
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 10,
                          marginBottom: 10,
                          paddingLeft: 15,
                          paddingRight: 20,
                          cursor: "pointer",
                        }}
                        onClick={goToGeneral}
                      >
                        <Grid style={{ display: "flex", flexDirection: "row" }}>
                          <img
                            src={Image.liveGeneral}
                            className={classes.imageStyle}
                          />
                          <span
                            style={{
                              marginLeft: 15,
                              color: "#495057",
                              fontWeight: "bold",
                              lineHeight: "2.5rem",
                            }}
                          >
                            General
                          </span>
                        </Grid>
                        <Grid>
                          <img
                            src={Image.navigateGigantiq}
                            className={classes.imageStyleNavi}
                          />
                        </Grid>
                      </Grid>
                      <Divider className={classes.dividerStyle} />
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 10,
                          marginBottom: 10,
                          paddingLeft: 15,
                          paddingRight: 20,
                          cursor: "pointer",
                        }}
                        onClick={goToHome}
                      >
                        <Grid style={{ display: "flex", flexDirection: "row" }}>
                          <img
                            src={Image.liveHomeFire}
                            className={classes.imageStyle}
                          />
                          <span
                            style={{
                              marginLeft: 15,
                              color: "#495057",
                              fontWeight: "bold",
                              lineHeight: "2.5rem",
                            }}
                          >
                            Home and Fire
                          </span>
                        </Grid>
                        <Grid>
                          <img
                            src={Image.navigateGigantiq}
                            className={classes.imageStyleNavi}
                          />
                        </Grid>
                      </Grid>
                      <Divider className={classes.dividerStyle} />

                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 10,
                          marginBottom: 10,
                          paddingLeft: 15,
                          paddingRight: 20,
                          cursor: "pointer",
                        }}
                        onClick={goToMaid}
                      >
                        <Grid style={{ display: "flex", flexDirection: "row" }}>
                          <img
                            src={Image.liveMaid}
                            className={classes.imageStyle}
                          />

                          <span
                            style={{
                              marginLeft: 15,
                              color: "#495057",
                              fontWeight: "bold",
                              lineHeight: "2.5rem",
                            }}
                          >
                            Maid
                          </span>
                        </Grid>
                        <Grid>
                          <img
                            src={Image.navigateGigantiq}
                            className={classes.imageStyleNavi}
                          />
                        </Grid>
                      </Grid>
                      <Divider className={classes.dividerStyle} />

                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 10,
                          marginBottom: 10,
                          paddingLeft: 15,
                          paddingRight: 20,
                          cursor: "pointer",
                        }}
                        onClick={goToMotor}
                      >
                        <Grid style={{ display: "flex", flexDirection: "row" }}>
                          <img
                            src={Image.liveMotor}
                            className={classes.imageStyle}
                          />

                          <span
                            style={{
                              marginLeft: 15,
                              color: "#495057",
                              fontWeight: "bold",
                              lineHeight: "2.5rem",
                            }}
                          >
                            Motor
                          </span>
                        </Grid>
                        <Grid>
                          <img
                            src={Image.navigateGigantiq}
                            className={classes.imageStyleNavi}
                          />
                        </Grid>
                      </Grid>
                      <Divider className={classes.dividerStyle} />

                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 10,
                          marginBottom: 10,
                          paddingLeft: 15,
                          paddingRight: 20,
                          cursor: "pointer",
                        }}
                        onClick={goToSaving}
                      >
                        <Grid style={{ display: "flex", flexDirection: "row" }}>
                          <img
                            src={Image.liveSavings}
                            className={classes.imageStyle}
                          />
                          <span
                            style={{
                              marginLeft: 15,
                              color: "#495057",
                              fontWeight: "bold",
                              lineHeight: "2.5rem",
                            }}
                          >
                            Saving
                          </span>
                        </Grid>
                        <Grid>
                          <img
                            src={Image.navigateGigantiq}
                            className={classes.imageStyleNavi}
                          />
                        </Grid>
                      </Grid>
                      <Divider className={classes.dividerStyle} />
                    </>
                  ) : null}

                <Grid
                  container
                  spacing={2}
                  direction="row"
                  style={{
                    marginTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 20,
                    paddingRight: 20,
                    overflowX:"hidden",
                    overflowY:"hidden"
                  }}
                >
                  <Grid item xs={12} sm={9} style={{display:"flex",flexDirection:"row"}}>
                      <img src={Image.upDownIcon} style={{width:"0.6rem",height:"0.6rem",marginRight:"0.2rem",marginTop:"1rem"}} onClick={onClickMenu}/>
                    <CustomText style={{lineHeight:"2.5rem",marginRight:"3%",cursor:"pointer"}} onClick={onClickMenu} >Menu</CustomText>
                    <CustomTextInput
                      id={"inbox-reply"}
                      design={classes.inputStyle}
                      placeholder="Enter Message..."
                      endAdornment={
                        hideLiveChat ? 
                        <InputAdornment position="end">
                          {handleAttachedFiles()}
                        </InputAdornment> : ""
                      }
                      borderline={false}
                      fullWidth={true}
                      disabled={closeMessageStatus || blockTheChat}
                      // disabled={false}
                      onChange={handleMessageChange}
                      value={userMsg}
                      maxLengthFlag={true}
                    />
                  </Grid>
                 

                  <Grid item xs={12} sm={3}>
                    <CustomButton
                      design={
                        !closeMessageStatus
                          ? classes.sendButtonStyle
                          : classes.disabledSendButtonStyle
                      }
                      style={{
                        backgroundColor: !closeMessageStatus
                          ? "#00B4AF"
                          : "#aaaaaa",
                        color: !closeMessageStatus ? "#fff" : "",
                      }}
                      disabled={closeMessageStatus}
                      // disabled={false}
                      variant={closeMessageStatus ? "text" : "outlined"}
                      // variant={"outlined"}
                      onClick={onClickSendMessageNormal}
                      title={"Send"}
                      icon={<SendIcon className={classes.sendIconStyle} />}
                    />
                  </Grid>
                </Grid>
              </CustomPaper>
            </Grid>
            {/* <Grid item xs={12} sm={3}>
              {showCat ? (
                <CustomPaper design={classes.paperStyleSecond}>
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justify="flex-start"
                    style={{ padding: 20 }}
                  >
                    <CustomText design={classes.subtitle}>
                      Popular Topics
                    </CustomText>
                  </Grid>
                  <Divider className={classes.dividerStyle} />
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: 10,
                      marginBottom: 10,
                      paddingLeft: 15,
                      paddingRight: 20,
                      cursor: "pointer",
                    }}
                    onClick={goToGeneral}
                  >
                    <Grid style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={Image.liveGeneral}
                        className={classes.imageStyle}
                      />
                      <span
                        style={{
                          marginLeft: 15,
                          color: "#495057",
                          fontWeight: "bold",
                          lineHeight: "2.5rem",
                        }}
                      >
                        General
                      </span>
                    </Grid>
                    <Grid>
                      <img
                        src={Image.navigateGigantiq}
                        className={classes.imageStyleNavi}
                      />
                    </Grid>
                  </Grid>
                  <Divider className={classes.dividerStyle} />
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: 10,
                      marginBottom: 10,
                      paddingLeft: 15,
                      paddingRight: 20,
                      cursor: "pointer",
                    }}
                    onClick={goToHome}
                  >
                    <Grid style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={Image.liveHomeFire}
                        className={classes.imageStyle}
                      />
                      <span
                        style={{
                          marginLeft: 15,
                          color: "#495057",
                          fontWeight: "bold",
                          lineHeight: "2.5rem",
                        }}
                      >
                        Home and Fire
                      </span>
                    </Grid>
                    <Grid>
                      <img
                        src={Image.navigateGigantiq}
                        className={classes.imageStyleNavi}
                      />
                    </Grid>
                  </Grid>
                  <Divider className={classes.dividerStyle} />

                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: 10,
                      marginBottom: 10,
                      paddingLeft: 15,
                      paddingRight: 20,
                      cursor: "pointer",
                    }}
                    onClick={goToMaid}
                  >
                    <Grid style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={Image.liveMaid}
                        className={classes.imageStyle}
                      />

                      <span
                        style={{
                          marginLeft: 15,
                          color: "#495057",
                          fontWeight: "bold",
                          lineHeight: "2.5rem",
                        }}
                      >
                        Maid
                      </span>
                    </Grid>
                    <Grid>
                      <img
                        src={Image.navigateGigantiq}
                        className={classes.imageStyleNavi}
                      />
                    </Grid>
                  </Grid>
                  <Divider className={classes.dividerStyle} />

                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: 10,
                      marginBottom: 10,
                      paddingLeft: 15,
                      paddingRight: 20,
                      cursor: "pointer",
                    }}
                    onClick={goToMotor}
                  >
                    <Grid style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={Image.liveMotor}
                        className={classes.imageStyle}
                      />

                      <span
                        style={{
                          marginLeft: 15,
                          color: "#495057",
                          fontWeight: "bold",
                          lineHeight: "2.5rem",
                        }}
                      >
                        Motor
                      </span>
                    </Grid>
                    <Grid>
                      <img
                        src={Image.navigateGigantiq}
                        className={classes.imageStyleNavi}
                      />
                    </Grid>
                  </Grid>
                  <Divider className={classes.dividerStyle} />

                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: 10,
                      marginBottom: 10,
                      paddingLeft: 15,
                      paddingRight: 20,
                      cursor: "pointer",
                    }}
                    onClick={goToSaving}
                  >
                    <Grid style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={Image.liveSavings}
                        className={classes.imageStyle}
                      />
                      <span
                        style={{
                          marginLeft: 15,
                          color: "#495057",
                          fontWeight: "bold",
                          lineHeight: "2.5rem",
                        }}
                      >
                        Saving
                      </span>
                    </Grid>
                    <Grid>
                      <img
                        src={Image.navigateGigantiq}
                        className={classes.imageStyleNavi}
                      />
                    </Grid>
                  </Grid>
                  <Divider className={classes.dividerStyle} />
                </CustomPaper>
              ) : (
                false
              )}
              {toGeneral ? renderGeneralQuestion() : false}
              {toHome ? renderHomeQuestion() : false}
              {toMaid ? renderMaidQuestion() : false}
              {toSaving ? renderSavingQuestion() : false}
              {toMotor ? renderMotorQuestion() : false}
            </Grid> */}
          </Grid>
        </Zoom>

        <CustomModalV2
          open={startInit}
          isWhiteCloseIcon={true}
          handleClose={onCloseLiveChat}
          modalTitle={"Live Chat"}
          isTitleCenter
          titlestyle={classes.modalTitleStyle}
          modalDesign={classes.modalDesign}
          //submitButtonText={"Confirm"}
          modalComponent={renderReviewConfirmDialog()}
          disableBackdropClick
          //handleSubmitButton={this.onClickConfirmReview}
          buttonStyle={{ justifyContent: "center" }}
        />
      </div>
    </Zoom>
  );
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: "50px",
  },
  toggleOffStyle: {
    width: 57,
    height: 35,
    " &:focus ": {
      outline: "none",
    },
  },
  toggleOpenStyle: {
    width: 57,
    height: 35,
    color: Color.primaryColor,
    " &:focus ": {
      outline: "none",
    },
  },
  spacing: {
    paddingLeft: "0.7em",
  },
  alertMsg: {
    borderRadius: "6px",
    backgroundColor: Color.inboxCloseContainerColor,
    marginTop: 20,
  },
  alertTextStyle: {
    color: Color.white,
    ...getFontWeight("600"),
    textAlign: "center",
  },
  header: {
    fontSize: "21px",
    ...getFontWeight("800"),
    marginBottom: "20px",
  },
  subtitle: {
    ...getFontWeight("800"),
  },
  bFont: {
    ...getFontWeight("600"),
    marginTop: 8,
  },
  buttonStyle: {
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    textTransform: "none",
    width: "96px",
    height: "35px",
    border: "1px solid",
    borderRadius: "5px",
    marginTop: "-3em",
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
  },
  buttonP: {
    paddingLeft: "1em",
    [theme.breakpoints.down("xs")]: {
      marginTop: 40,
    },
    marginTop: "-0.5em",
  },
  inputStyle: {
    borderRadius: "10px",
    backgroundColor: Color.inboxBackgroundColor,
    height: 39,
    width: window.innerWidth * 0.63
  },
  dividerStyle: {
    backgroundColor: Color.dividerColor,
  },
  paperStyle: {
    padding: 0,
    //height: 700,
    marginTop: 100,
    marginBottom: 40,
    maxWidth: 700,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: "1px solid #f1f2f8",
    overflowY: "scroll",
    overflowX: "hidden",
    "&::-webkit-scrollbar": { width: "1px" },
    "&::-webkit-scrollbar-track": { background: "#f1f2f8" },
    "&::-webkit-scrollbar-thumb": { background: "#E0E0E0" },
  },
  paperStyleSecond: {
    padding: 0,
    //height: 700,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "1px solid #f1f2f8",
    overflowY: "scroll",
    overflowX: "hidden",
    "&::-webkit-scrollbar": { width: "3px" },
    "&::-webkit-scrollbar-track": { background: "#f1f2f8" },
    "&::-webkit-scrollbar-thumb": { background: "#E0E0E0" },
  },
  leftContainerPaper: {
    padding: 0,
  },
  divStyle: {
    padding: 20,
  },
  sendButtonStyle: {
    backgroundColor: "#00B4AF",
    color: "#fff",
    height: 39,
    border: 0,
  },
  disabledSendButtonStyle: {
    backgroundColor: "#aaaaaa",
    height: 39,
    border: 0,
  },
  attachIconStyle: {
    color: Color.secondaryTextColor,
    width: 20,
    height: 20,
    cursor: "pointer",
  },
  disabledAttachIconStyle: {
    color: Color.placeHolderTextColor,
    width: 20,
    height: 20,
  },
  sendIconStyle: {
    fontSize: 17,
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
      marginLeft: 5,
    },
  },
  selectedImageStyle: {
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 40,
    },
    [theme.breakpoints.up("sm")]: {
      width: 80,
      height: 80,
    },
    borderRadius: 5,
  },
  cancelIconStyle: {
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
    },
    color: Color.debitTextColor,
    marginTop: 5,
    textAlign: "center",
    ...getFontSize("xxsmall"),
    textDecoration: "underline",
    cursor: "pointer",
  },
  imageStyle: {
    width: "40px",
    height: "40px",
  },
  imageStyleNavi: {
    width: "20px",
    height: "20px",
    marginTop: 9,
  },
  imageLiveChatStyle: {
    width: "95px",
    height: "40px",
  },
  threeSelect: {
    border: "1px solid #00B4AF",
    borderRadius: "18px",
    padding: 10,
    width: "100%",
    //height: "30px",
    textAlign: "center",
    // lineHeight: "10px",
    marginRight: 20,
    color: "#00B4AF",
  },
  modalDesign: {
    background:
      "transparent linear-gradient(318deg, #67BB97 0%, #0B4F83 100%) 0% 0% no-repeat padding-box",
    minHeight: "500px",
    maxWidth: "500px",
    marginTop: "3rem",
  },
  modalTitleStyle: {
    color: "#fff",
    fontSize: "16px",
  },
});

function mapStateToProps(state) {
  return {
    // getEDocFilterParamLoading: selector.getEDocFilterParamLoading(state),
    // getEDocFilterParamData: selector.getEDocFilterParamData(state),
    // getEDocFilterParamStatus: selector.getEDocFilterParamStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // getEDocFilterParam: () => dispatch(profileAction.getEDocFilterParam()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(WebView)));
